export interface ILoadingHandler {
    startTimeout(): void;
    stopTimeout(): void;
}

// If the request hasn't finished for `TIMEOUT_MS` time, we show the loading icon
export const TIMEOUT_MS = 100;

/**
 * Responsible for handling the loading state of the search box.
 * Loading starts a bit after the request is sent, so we avoid loading icon flickering.
 */
export class LoadingHandler implements ILoadingHandler {
    private timeout: NodeJS.Timeout = null;
    isLoading = false;

    startTimeout() {
        this.stopTimeout();

        this.timeout = setTimeout(() => {
            this.isLoading = true;
        }, TIMEOUT_MS);
    }

    stopTimeout() {
        this.isLoading = false;

        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
    }
}
